// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 
  Register Page Styling
  A simple, centered card layout with responsive design
*/

/* Root container that centers the form vertically and horizontally */
.register-container {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100vh; /* full viewport height */
    background-color: #f8f9fa; /* neutral background */
    margin: 0;
    padding: 20px;
  }
  
  /* The "card" that holds the form */
  .register-card {
    background-color: #fff;
    border-radius: 8px;
    max-width: 400px;  /* limit form width on large screens */
    width: 100%;
    padding: 30px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
  
  /* Title styling */
  .register-title {
    font-size: 24px;
    margin-bottom: 20px;
    text-align: center;
    color: #333;
  }
  
  /* Error message styling */
  .error-message {
    color: #dc3545;
    margin-bottom: 15px;
    font-size: 14px;
    text-align: center;
  }
  
  /* Form container */
  .register-form {
    display: flex;
    flex-direction: column;
  }
  
  /* Each field (label + input) */
  .form-group {
    margin-bottom: 15px;
  }
  
  /* Labels for each input field */
  .form-group label {
    display: block;
    margin-bottom: 5px;
    color: #333;
    font-weight: 500;
  }
  
  /* Inputs styling */
  .form-group input {
    width: 100%;
    padding: 10px;
    font-size: 14px;
    border-radius: 4px;
    border: 1px solid #ccc;
    box-sizing: border-box;
  }
  
  /* Register button styling */
  .register-button {
    background-color: #007bff; /* primary color */
    color: #fff;
    font-size: 16px;
    border: none;
    padding: 12px 0;
    border-radius: 4px;
    cursor: pointer;
    width: 100%;
    margin-top: 5px;
    transition: background-color 0.3s ease;
  }
  
  .register-button:hover {
    background-color: #0056b3; /* darker on hover */
  }
  
  /* 
    Responsive Media Queries 
    For smaller screens (e.g., phones), 
    we may slightly reduce padding and font sizes
  */
  @media (max-width: 480px) {
    .register-card {
      padding: 20px;
    }
  
    .register-title {
      font-size: 20px;
    }
  
    .form-group input {
      font-size: 14px;
    }
  
    .register-button {
      font-size: 14px;
      padding: 10px 0;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/Register.css"],"names":[],"mappings":"AAAA;;;CAGC;;AAED,qEAAqE;AACrE;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB,EAAE,yBAAyB;IAC5C,yBAAyB,EAAE,uBAAuB;IAClD,SAAS;IACT,aAAa;EACf;;EAEA,mCAAmC;EACnC;IACE,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB,GAAG,sCAAsC;IACzD,WAAW;IACX,aAAa;IACb,wCAAwC;EAC1C;;EAEA,kBAAkB;EAClB;IACE,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;EACb;;EAEA,0BAA0B;EAC1B;IACE,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,kBAAkB;EACpB;;EAEA,mBAAmB;EACnB;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA,+BAA+B;EAC/B;IACE,mBAAmB;EACrB;;EAEA,gCAAgC;EAChC;IACE,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,gBAAgB;EAClB;;EAEA,mBAAmB;EACnB;IACE,WAAW;IACX,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;EACxB;;EAEA,4BAA4B;EAC5B;IACE,yBAAyB,EAAE,kBAAkB;IAC7C,WAAW;IACX,eAAe;IACf,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,yBAAyB,EAAE,oBAAoB;EACjD;;EAEA;;;;GAIC;EACD;IACE;MACE,aAAa;IACf;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;MACf,eAAe;IACjB;EACF","sourcesContent":["/* \n  Register Page Styling\n  A simple, centered card layout with responsive design\n*/\n\n/* Root container that centers the form vertically and horizontally */\n.register-container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 100vh; /* full viewport height */\n    background-color: #f8f9fa; /* neutral background */\n    margin: 0;\n    padding: 20px;\n  }\n  \n  /* The \"card\" that holds the form */\n  .register-card {\n    background-color: #fff;\n    border-radius: 8px;\n    max-width: 400px;  /* limit form width on large screens */\n    width: 100%;\n    padding: 30px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  }\n  \n  /* Title styling */\n  .register-title {\n    font-size: 24px;\n    margin-bottom: 20px;\n    text-align: center;\n    color: #333;\n  }\n  \n  /* Error message styling */\n  .error-message {\n    color: #dc3545;\n    margin-bottom: 15px;\n    font-size: 14px;\n    text-align: center;\n  }\n  \n  /* Form container */\n  .register-form {\n    display: flex;\n    flex-direction: column;\n  }\n  \n  /* Each field (label + input) */\n  .form-group {\n    margin-bottom: 15px;\n  }\n  \n  /* Labels for each input field */\n  .form-group label {\n    display: block;\n    margin-bottom: 5px;\n    color: #333;\n    font-weight: 500;\n  }\n  \n  /* Inputs styling */\n  .form-group input {\n    width: 100%;\n    padding: 10px;\n    font-size: 14px;\n    border-radius: 4px;\n    border: 1px solid #ccc;\n    box-sizing: border-box;\n  }\n  \n  /* Register button styling */\n  .register-button {\n    background-color: #007bff; /* primary color */\n    color: #fff;\n    font-size: 16px;\n    border: none;\n    padding: 12px 0;\n    border-radius: 4px;\n    cursor: pointer;\n    width: 100%;\n    margin-top: 5px;\n    transition: background-color 0.3s ease;\n  }\n  \n  .register-button:hover {\n    background-color: #0056b3; /* darker on hover */\n  }\n  \n  /* \n    Responsive Media Queries \n    For smaller screens (e.g., phones), \n    we may slightly reduce padding and font sizes\n  */\n  @media (max-width: 480px) {\n    .register-card {\n      padding: 20px;\n    }\n  \n    .register-title {\n      font-size: 20px;\n    }\n  \n    .form-group input {\n      font-size: 14px;\n    }\n  \n    .register-button {\n      font-size: 14px;\n      padding: 10px 0;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
